import accountApi from '../account/accountApi';
import type { ChangePasswordPayload } from '../../types';

export const accountService = {
  /**
   * Change the authenticated user's password
   */
  changePassword: (payload: ChangePasswordPayload) =>
    accountApi.changePassword(payload),
    
  /**
   * Deletes the authenticated user's account
   */
  deleteMyAccount: () => accountApi.deleteMyAccount(),
};

export default accountService;
